import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { fetchOrders } from '../../store/actions/index';
import CircularProgress from '@mui/material/CircularProgress';
import styled from 'styled-components';
import Order from '../../components/Order/Order';
import Grid from '@mui/material/Grid';

const OrdersContainer = styled.div`
    min-height: 100vh;
    padding: 10% 5%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;


const Orders = ( props ) => {

    const { orders , fetchingOrders, fetchOrdersHandler } = props;

    useEffect( () => {
        fetchOrdersHandler();
    } , [ fetchOrdersHandler ] )

    const loadingOrdersContent = <CircularProgress />

    let  fetchedOrders = [];

    if(orders.length > 0) {
        fetchedOrders =orders.map( ( order, i ) => {
            return(
                <Grid item xs={12} sm={12} md={12} xl={12} key={order.orderId}>
                    <Order address={order.address} city={order.city} name={order.name} 
                        orderContent={order.orderContent} payment={order.payment} 
                        shipping={order.shipping} subTotal={order.subTotal}  />
                </Grid>
            )
        })
    }

    const fetchedOrdersContent = (
            <Grid container spacing={ 4 } >
                {fetchedOrders}
            </Grid>
        ) 

    return (
        <OrdersContainer>
            {fetchingOrders && loadingOrdersContent}
            {orders.length > 0 && !fetchingOrders && fetchedOrdersContent}
        </OrdersContainer>
    )
}

const mapStateToProps = ( state) => {
    return {
        orders: state.orders.orders,
        fetchingOrders: state.orders.fetchingOrders,
    }
}
const mapDispatchToProps = ( dispatch ) => {
    return {
        fetchOrdersHandler: ( ) => dispatch( fetchOrders( ) ),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Orders);